import { Template } from '@pdfme/common';

import { GetDocumentTemplateResponse } from 'src/features/documents/models';
import {
  CredentialTemplateField,
  LabelTypes,
  TEMPLATE_FIELD_TYPES,
} from 'src/features/templates/models';

type SchemaRecord = Record<string, { type: string; [key: string]: unknown }>;

export const toPersistedTemplate = (designerTemplate: Template) => {
  const page = designerTemplate.schemas[0] as SchemaRecord;
  const keys = Object.keys(page);

  const schemas = Object.fromEntries(
    keys.map((key) => {
      const currentType = page[key].type;
      return [
        key,
        {
          ...page[key],
          type: TEMPLATE_FIELD_TYPES[currentType as LabelTypes] ?? currentType,
        },
      ];
    })
  );

  const renderParams = Object.fromEntries(
    keys.map((key) => {
      const currentType = page[key].type;
      const label =
        designerTemplate.sampledata &&
        Object.prototype.hasOwnProperty.call(
          designerTemplate.sampledata[0],
          key
        )
          ? currentType === LabelTypes.FIXED_TEXT
            ? designerTemplate.sampledata[0][key]
            : key
          : '';
      return [
        key,
        {
          fieldLabel: label,
          fieldType: currentType,
        },
      ];
    })
  ) as Record<string, CredentialTemplateField>;

  return { schemas, renderParams };
};

export const toDesignerTemplate = (
  design: GetDocumentTemplateResponse,
  renderParams: Record<string, CredentialTemplateField>
): Template => {
  const page = design.schemas[0] as SchemaRecord;
  const keys = Object.keys(page);

  const schemas = [
    Object.fromEntries(
      keys.map((key) => {
        const fieldType = renderParams[key]?.fieldType;
        return [
          key,
          {
            ...page[key],
            type: fieldType ?? page[key].type,
          },
        ];
      })
    ),
  ];

  const sampledata = [
    Object.fromEntries(
      keys.map((key) => {
        const fieldType = renderParams[key]?.fieldType;
        if (fieldType === LabelTypes.FIXED_TEXT) {
          return [key, renderParams[key].fieldLabel];
        }
        if (fieldType === LabelTypes.IMAGE) {
          return [key, ''];
        }
        return [key, key];
      })
    ),
  ];

  return {
    basePdf: design.basePdf,
    schemas: schemas as Template['schemas'],
    sampledata,
  };
};
